import React, { useEffect } from 'react';
import './Build.css'; // スタイルシートをインポート

function OptionSelect({ startMonth, setStartMonth, startDay, setStartDay, language, setLanguage, selectedFrame, setSelectedFrame, onOptionsChange }) {
  const months = [
    '1月', '2月', '3月', '4月', '5月', '6月',
    '7月', '8月', '9月', '10月', '11月', '12月'
  ];
  const days = ['日', '月'];
  const languages = ['英語', '日本語'];
  const frames = [
    { thumbnail: '/assets/frame/frame1.jpg', name: 'スタンダード', price: 0 },
    // { thumbnail: '/assets/frames/frame2.jpg', name: 'くるま', price: 300 },
    // { thumbnail: '/assets/frames/frame3.jpg', name: 'でんしゃ', price: 300 },
    // { thumbnail: '/assets/frames/frame4.jpg', name: 'むし', price: 300 },
    // { thumbnail: '/assets/frames/frame5.jpg', name: 'ようふく', price: 0 },
    // { thumbnail: '/assets/frames/frame6.jpg', name: 'くまたん', price: 300 },
    // { thumbnail: '/assets/frames/frame7.jpg', name: 'おすなば', price: 300 },
    // { thumbnail: '/assets/frames/frame8.jpg', name: 'おふろ', price: 300 },
    // { thumbnail: '/assets/frames/frame9.jpg', name: 'おふとん', price: 0 },
    // { thumbnail: '/assets/frames/frame10.jpg', name: 'えほん', price: 300 },
    // { thumbnail: '/assets/frames/frame11.jpg', name: 'くれよん', price: 300 },
    // { thumbnail: '/assets/frames/frame12.jpg', name: 'フレームを依頼', price: 1500 },
  ];

  OptionSelect.frames = frames; // フレームの価格情報をエクスポート

  useEffect(() => {
    if (!startMonth) {
      console.log(new Date().getMonth() + 1)
      setStartMonth(new Date().getMonth() + 1); // 現在の月をデフォルトとして設定
    }
    onOptionsChange({
      startMonth,
      startDay,
      language,
      selectedFrame,
    });
  }, [startMonth, startDay, language, selectedFrame, onOptionsChange, setStartMonth]);

  return (
    <div className="option-select">
      <h4 className="h4">③ オプション選択（任意）</h4>
      <div className="option_item">
        <label className="option_label">始まり月<span>（デフォルトは今月始まり）</span></label>
        <select value={startMonth} onChange={(e) => setStartMonth(parseInt(e.target.value))} className="option_select">
          {months.map((month, index) => (
            <option key={index} value={index + 1}>{month}</option>
          ))}
        </select>
      </div>
      <div className="option_item">
        <label className="option_label">始まる曜日<span>（デフォルトは日曜始まり）</span></label>
        <select value={startDay} onChange={(e) => setStartDay(parseInt(e.target.value))} className="option_select">
          {days.map((day, index) => (
            <option key={index} value={index}>{day}</option>
          ))}
        </select>
      </div>
      <div className="option_item">
        <label className="option_label">曜日の言語<span>（デフォルトは英語）</span></label>
        <select value={language} onChange={(e) => setLanguage(e.target.value)} className="option_select">
          {languages.map((lang, index) => (
            <option key={index} value={lang}>{lang}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="option_label">フレーム選択<span>（デフォルトはスタンダード）</span></label>
        <div className="frame-grid">
          {frames.map((frame, index) => (
            <div key={index} className="frame-option">
              <img
                src={frame.thumbnail}
                alt={`frame-${index}`}
                className={`frame-thumbnail ${selectedFrame === index ? 'selected' : ''}`}
                onClick={() => setSelectedFrame(index)}
              />
              <div className="frame-info">
                <p className="frame_name">{frame.name}</p>
                <p className="frame_price">（追加料金：{frame.price}円）</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OptionSelect;
